// components/ProductCategories.jsx
import React from 'react';
import { Link } from 'react-router-dom';
import './ProductCategories.css';

const categories = [
  {
    id: 1,
    title: "limpiadores",
    link: "/shop?category=limpiadores",
    backgroundImage: "url('/images/secciones/curated-selection/grid-categorias-limpiadores.webp')"
  },
  {
    id: 2,
    title: "tonicos",
    link: "/shop?category=tonicos",
    backgroundImage: "url('/images/secciones/curated-selection/grid-categorias-tonicos.webp')"
  },
  {
    id: 3,
    title: "Hidratantes",
    link: "/shop?category=hidratantes",
    backgroundImage: "url('/images/secciones/curated-selection/grid-categorias-hidratantes.webp')"
  },
  {
    id: 4,
    title: "Kits",
    link: "/shop?category=kits",
    backgroundImage: "url('/images/secciones/curated-selection/grid-categorias kits.webp')"
  },
  {
    id: 5,
    title: "sueros",
    link: "/shop?category=sueros",
    backgroundImage: "url('/images/secciones/curated-selection/grid-categorias-sueros.webp')"
  },
  {
    id: 6,
    title: "sets",
    link: "/shop?category=sets",
    backgroundImage: "url('/images/secciones/curated-selection/grid-categorias-sets.webp')"
  }
];

const ProductCategories = () => {
  return (
    <section className="product-categories">
      <div className="categories-container">
        <div className="categories-header">
          <h2>Explora nuestros productos por categoría</h2>
        </div>

        <div className="categories-grid">
          {categories.map((category) => (
            <Link
              key={category.id}
              to={category.link}
              className="category-card"
              style={{ backgroundImage: category.backgroundImage }}
            >
              <div className="category-overlay"></div>
              <div className="category-header">
                <h3 className="category-title">{category.title}</h3>
              </div>
              <div className="category-hover-indicator"></div>
            </Link>
          ))}
        </div>

        <div className="categories-footer">
        </div>
      </div>
    </section>
  );
};

export default ProductCategories;
